module.exports = __webpack_public_path__ + "img/in-the-time-of-the-butterflies.4ea1741e.png";